import React from "react";

import { withRouter } from "react-router-dom";

import type { ContextRouter } from "react-router-dom";

export default function installOptimize() {
  (function (document) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://www.googleoptimize.com/optimize.js?id=OPT-535VJNQ";
    const element = document.getElementsByTagName("script")[0];
    // $FlowFixMe
    element.parentNode.insertBefore(script, element);
  })(document);
}

class OptimizeActivateComponent extends React.Component<ContextRouter> {
  componentDidMount() {
    this.triggerActivate();
    this.props.history.listen(this.triggerActivate);
  }

  triggerActivate() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "optimize.activate" });
  }

  render() {
    return null;
  }
}

const OptimizeActivate = withRouter(OptimizeActivateComponent);

export { OptimizeActivate };
